import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { OnlyBackButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { pointRecordQueryKey } from 'components/pointRecord/RecordsUrlConfig';
import { POINT_RECORD_TYPE } from 'config/CustomEnums';
import { POINT_TRANSACTION_TYPE } from 'containers/record/pointRecords/PointTransactionList';
import { TRANSACTION_RECORD_TYPE } from 'containers/record/records/TransactionList';
import { createAction } from 'utils';

export const getRecordsRelatedTransactionCard = (transaction) => (
  <MembershipInfoCard
    title="Related Transaction"
    data={transaction || {}}
    fields={[
      [{
        title: 'Transaction (Invoice ID)',
        field: transaction?.transactionDisplayType ===
          TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_POS
          ? 'posInvoiceId'
          : 'invoiceId',
        deeplink: `/transactions/${transaction?.pk}/`
      }],
      [{ title: 'Transaction date', field: 'transactionDetailDisplayDate' }],
      [{ title: 'Transaction value', field: 'displayPaidAmount' }],
      [{ title: 'Eligible total', field: 'displayTotalValue' }],
    ]}
  />)


function PointTransactionOverview({ selectedPointRecord }) {
  const queryString = require('query-string');
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'pointTransactionList/getSinglePointRecord',
      payload: {
        pointRecordPK: params.id,
      },
    });
    return () => dispatch(createAction("pointTransactionList/updateState")({
      selectedPointTransaction: {}
    }))
  }, [dispatch, params.id]);

  const getPointDetailSectionFieldsWithType = (pointType) => {
    let extraFields = [];
    if (pointType === 'Remove point') {
      extraFields = extraFields.concat([
        [{ title: 'Used date (optional)', field: 'useDate' }],
        [{ title: 'Used type (optional)', field: 'usedDisplayType' }],
      ]);
    }
    return [
      [{ title: 'Gift card code', field: 'giftCardCode' }],
      [{ title: 'Points', field: 'displayDetailPoints' }],
      [{ title: 'Loyalty Point', field: 'loyaltyPoints' }],
      [{ title: 'Gift card Point', field: 'giftCardPoints' }],
      [{ title: 'Progression Points', field: 'displayDetailTpe' }],
      [{ title: 'Point source', field: 'pointSource' }],
      ...extraFields,
      [{ title: 'Remarks (optional)', field: 'remarks', isRichText: true }],
      [{ title: 'Expiry date (optional)', field: 'expiryDate' }],
    ];
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={'POINT RECORD DETAILS'}
                data={selectedPointRecord}
                fields={[
                  [{ title: 'Customer', field: 'name', customerLink: true }],
                  [{ title: 'Membership ID', field: 'membershipId' }],
                  [
                    {
                      title: 'Transaction Type',
                      field: 'transactionDisplayType',
                    },
                  ],
                ].concat(
                  [
                    POINT_TRANSACTION_TYPE.MERCHANT_USE_CASH_DOLLAR,
                    POINT_TRANSACTION_TYPE.ADMIN_EDITED,
                    POINT_TRANSACTION_TYPE.MERCHANT_EDITED,
                  ].includes(selectedPointRecord?.transactionDisplayType)
                    ? [
                        [
                          {
                            title: 'Admin User',
                            field: 'displayAdministrator',
                          },
                        ],
                      ]
                    : [],
                )}
              />,
              <MembershipInfoCard
                title={
                  selectedPointRecord.pointDisplayType ===
                  POINT_RECORD_TYPE.TYPE_ADD
                    ? 'ADD POINT'
                    : 'REMOVE POINT'
                }
                data={selectedPointRecord}
                fields={getPointDetailSectionFieldsWithType(
                  selectedPointRecord.pointDisplayType,
                )}
              />,
              <MembershipInfoCard
                title="GENERAL"
                data={selectedPointRecord}
                fields={[
                  [{ title: 'Purchase date', field: 'detailDisplayPurchaseDate' }],
                  [{ title: 'Creation date', field: 'detailDisplayCreationDate' }],
                ]}
              />,
              ...(selectedPointRecord?.transaction?.pk ? [
                getRecordsRelatedTransactionCard(selectedPointRecord.transaction)
              ] : []),
              ...selectedPointRecord?.reachLimitInfo?.isPointsReachLimit ?
                [<MembershipInfoCard
                  title="points reached limit"
                  data={selectedPointRecord.reachLimitInfo}
                  fields={selectedPointRecord.reachLimitInfo?.pointsShowTransactionValue
                    ? [
                      [{ title: 'Limit', field: 'pointsDisplayLimit' }],
                      [{ title: 'Maximum transaction limit', field: 'pointsDisplayMaximumRewardLimit' }],
                      [{ title: 'Accumulated spend', field: 'pointsDisplayAccumulatedReward' }],
                      [{ title: 'Original transaction value', field: 'originalTransactionValue' }],
                      [{ title: 'Original reward from this record', field: 'pointsDisplayOriginalReward' }],
                      [{ title: 'Final reward', field: 'pointsDisplayFinalReward' }],
                    ]
                    : [
                      [{ title: 'Limit', field: 'pointsDisplayLimit' }],
                      [{ title: 'Maximum reward limit', field: 'pointsDisplayMaximumRewardLimit' }],
                      [{ title: 'Accumulated reward', field: 'pointsDisplayAccumulatedReward' }],
                      [{ title: 'Original reward from this record', field: 'pointsDisplayOriginalReward' }],
                      [{ title: 'Final reward', field: 'pointsDisplayFinalReward' }],
                    ]}
                />] : [],
              ...selectedPointRecord?.reachLimitInfo?.isPpReachLimit ?
                [<MembershipInfoCard
                  title="Progression points reached limit"
                  data={selectedPointRecord.reachLimitInfo}
                  fields={selectedPointRecord.reachLimitInfo?.ppShowTransactionValue
                    ? [
                      [{ title: 'Limit', field: 'ppDisplayLimit' }],
                      [{ title: 'Maximum transaction limit', field: 'ppDisplayMaximumRewardLimit' }],
                      [{ title: 'Accumulated spend', field: 'ppDisplayAccumulatedReward' }],
                      [{ title: 'Original transaction value', field: 'originalTransactionValue' }],
                      [{ title: 'Original reward from this record', field: 'ppDisplayOriginalReward' }],
                      [{ title: 'Final reward', field: 'ppDisplayFinalReward' }],
                    ]
                    : [
                    [{ title: 'Limit', field: 'ppDisplayLimit' }],
                    [{ title: 'Maximum reward limit', field: 'ppDisplayMaximumRewardLimit' }],
                    [{ title: 'Accumulated reward', field: 'ppDisplayAccumulatedReward' }],
                    [{ title: 'Original reward from this record', field: 'ppDisplayOriginalReward' }],
                    [{ title: 'Final reward', field: 'ppDisplayFinalReward' }],
                  ]}
                />] : [],
            ]}
            hidePreview={true}
            sectionStyle="transaction-record-detail-section"
          />
        </div>
      ),
    },
  ];

  // const buttons = [
  //   <Button
  //     className="btn-further"
  //     onClick={() => {
  //       history.push(`/point_records/${selectedPointRecord.pk}/edit`);
  //     }}
  //   >
  //     Edit
  //   </Button>,
  // ];
  return (
    <>
      <CustomListComponent
        caution={{
          detail: '', //view point records
          title: 'View Point records',
        }}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={true}
        tabs={tabs}
        buttons={[]}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: '/point_records',
            search: queryString.stringify({
              [pointRecordQueryKey.page]: 1,
              [pointRecordQueryKey.rank]: true,
              [pointRecordQueryKey.searchKey]: '',
            }),
          });
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  selectedPointRecord: state.pointTransactionList.selectedPointTransaction,
});

export default connect(mapPropsToState)(PointTransactionOverview);
